import React, { useEffect, useRef, useState } from "react";
import { FilterWrapper } from "../../../assets/styles/FilterStyle.js";
import { TableWrapper } from "../../../Components/styledConstant.js";
import { AddNewHotel, getHotelList, getSuggestList, UpdateHotelStatus } from "../../../utils/api.js";
import Pagination from "../../../Components/Pagination/Pagination.jsx";
import ViewHotelDetails from "./ViewHotel.jsx";
import { useNavigate } from "react-router-dom";
import AutoSuggestion from "../../../Components/AutoSuggest/AutoSuggest.js";
import debounce from "lodash.debounce";
import Input from "../../../Components/Input/Input.jsx";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp.jsx";
import LocalLoader from "../../../Components/Loader/LocalLoader.js";
import { useDebounce } from "../../../Components/hooks/useDebounce.js";



const hotelfilterData = {
    hotelCode:null,
    hotelName:null,
    searchId:null,
    feedSource:null,
    active:null,


}

const initValue = {
  code: "",
  active: "",
  name:"",
  email: "",
  fax:"",
  phone:"",
  checkOutTime:"",
  checkInTime:"",
  starRating:"",
  countryCode:"",
  cityName:"",
  cityId:"",
  pinCode:"",
  description:"",
  geoPoint:"",
  address:"",
  feedSource:""
  
 
}

const HotelList = () => {
  const autoSuggestionRef = useRef(null);
    const [hotelList,setHotelList] = useState([]); 
    const [hoteldata,setHotelData] =  useState(hotelfilterData);
    const [cityData,setCityData] =  useState(hotelfilterData);
    const [totalPages, setTotalPages] = useState(null);
    const [totalElements, setTotalElements] = useState(null);
    const [currPage, setCurrPage] = useState(0);
    const [pageSize, setPageSize] = useState(15);
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [showHotel,SetShowHotel] = useState(false);
    const [newHotelData, setNewHotelData] = useState({...initValue});
  const [errors, setErrors] = useState({});
  const[loading,setLoading] = useState(false);

    const navigate = useNavigate();

    const handleViewCity = (cityId) => {
      navigate(`/hotel/view/hotel/${cityId}`); // Navigate to the city details page
    };
    const handleModalInputChange = (e) => {
      const { name, value } = e.target;
      
      
      
      
      setNewHotelData((prev) => ({
          ...prev,
          [name]: value,
      }));
  };


  

  const validateForm = () => {
    const newErrors = {};
  
    // Validate Hotel Code
    if (!newHotelData.code) {
      newErrors.code = "Hotel Code is required";
    }
  
    // Validate Hotel Name
    if (!newHotelData.name) {
      newErrors.name = "Hotel Name is required";
    }
  
    // Validate City ID (must be numeric)
    if (!newHotelData.cityId || isNaN(newHotelData.cityId)) {
      newErrors.cityId = "City ID must be a number";
    }
  
    // Validate City Name
    if (!newHotelData.cityName) {
      newErrors.cityName = "City Name is required";
    }
  
    // Validate Check-In Time
    if (!newHotelData.checkInTime) {
      newErrors.checkInTime = "Check-In time is required";
    }
  
    // Validate Check-Out Time
    if (!newHotelData.checkOutTime) {
      newErrors.checkOutTime = "Check-Out time is required";
    }
  
    // Validate Geo Point (latitude,longitude format)
    if (!newHotelData.geoPoint || !/^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(newHotelData.geoPoint)) {
      newErrors.geoPoint = "Geo Point must be in 'latitude,longitude' format";
    }
  
    // Validate Country Code (must be numeric)
    if (!newHotelData.countryCode || isNaN(newHotelData.countryCode)) {
      newErrors.countryCode = "Country Code must be a number";
    }
  
    // Validate Phone Number (must be numeric)
    if (!newHotelData.phone || isNaN(newHotelData.phone)) {
      newErrors.phone = "Phone Number must be a number";
    }
  
    // Validate Star Rating (must be numeric)
    if (!newHotelData.starRating || isNaN(newHotelData.starRating)) {
      newErrors.starRating = "Star Rating must be a number";
    }
  
    // Validate Address
    if (!newHotelData.address) {
      newErrors.address = "Address is required";
    }
  
    // Validate Pin Code (must be numeric)
    if (!newHotelData.pinCode || isNaN(newHotelData.pinCode)) {
      newErrors.pinCode = "Pin Code must be a number";
    }
  
    // Validate Email (valid email format)
    if (!newHotelData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newHotelData.email)) {
      newErrors.email = "Invalid email address";
    }
  
    // Validate Active Status
    if (!newHotelData.active  || newHotelData.active === null) {
      newErrors.active = "Status is required";
    }
    if (!newHotelData.fax) {
      newErrors.fax = "fax is required";
    }
  
    // Set errors state
    setErrors(newErrors);
  
    // Return true if no errors, false otherwise
    return Object.keys(newErrors).length === 0;
  };
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        autoSuggestionRef.current &&
        !autoSuggestionRef.current.contains(event.target)
      ) {
        setShowSuggestions(false); // Close the popup
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

    const fetchSuggestions = (query, identifier,type) => {
      getSuggestList(query, identifier,type)
        .then((resp) => {
          console.log("API Response:", resp?.data.data.suggestions); // Debug response
          if (resp?.data.data.suggestions) {
            setSuggestions([...resp?.data.data.suggestions]);
            setShowSuggestions(true);
           
          } else {
            setSuggestions([]);
            setShowSuggestions(false); // Handle no suggestions case
            
          }
        })
        .catch((error) => console.error("Error fetching suggestions:", error));
    };
    const debounceValue = useDebounce(hoteldata.hotelName, 500);
    const handleDetailData = (e) => {
      
        const { name, value } = e.target;
        setHotelData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name === "hotelName" && value.trim()) {
        } else{
          setSuggestions([]);
          setShowSuggestions(false);
  
        }
    };


    useEffect(() =>{
     fetchSuggestions(debounceValue, "loc","2")
    },[debounceValue])

const showHotelList = (page,key = "")=>{
console.log("setDetailData",hoteldata)
let param = {
    page:page,
    hotelCode:hoteldata?.hotelCode,
    searchId:hoteldata?.searchId,
 //   countryCode:"",
  //  cityId:"",
    active:hoteldata?.active
   
}

if(key === "refresh"){
    param.hotelCode = "";

   setHotelData(hotelfilterData);
   param = hotelfilterData;
}

     setLoading(true);
    getHotelList(param).then((resp)=>{
         setLoading(false);
        if(resp){
            
            setHotelList(resp?.data?.data?.hotels?.content);
            setTotalPages(resp?.data?.data?.hotels?.totalPages)
            setTotalElements(resp?.data?.data?.hotels?.totalElements)
        
        }
    


    })
}

const currPageSet = (currentPage) =>{
    showHotelList(currentPage)
setCurrPage(currentPage);
}






useEffect(()=>{
showHotelList(currPage);
},[])


const handleAddHotel = (key = "")=>{
  if(key == "add"){
    SetShowHotel((prev) => prev ? false: true);
  }

  if(key == "cancle"){
    setNewHotelData({...initValue})
    SetShowHotel((prev) => prev ? false: true);
  }
 
 // setNewHotelData(..newHotelData)

}

const handleSubmit = ()=>{
  if (!validateForm()) {
    console.log("Validation failed. Fix the errors before submitting.");
    return; // Stop further execution if validation fails
  }
  
if(newHotelData.active ==="true"){
  newHotelData.active = true
} else{
  newHotelData.active = false;
}
 
  AddNewHotel(newHotelData).then((resp)=>{

    console.log("res",resp);

  })
}
console.log("erro",hotelList);

const updateStatus =(id)=>{

UpdateHotelStatus(id).then((res)=>{
 if(res){
  showHotelList(currPage);
 }

})

}


    return(
        <>
         <div className="userlisthead_container">
         <div style={{ padding: "30px" }}>
         <div className="transaction_main_container">
         <div className="userlist_head">
            <div className="userlist_heading">
              <div className="userlist_left mb-5">
                <label>Hotel List</label>
              </div>
             
           
            </div>
          </div>
          <FilterWrapper style={{background:"#fff"}}>
          <div className="filterBox">
              <div style={{width:"100%"}}>
               <div>
                <p className="fw-bold">Total Hotels:  {totalElements}</p>
               </div>
              </div>

              <div>
            <button onClick={() => navigate("/hotel/addhotel")} className="userlist_btn">Add New Hotel</button>
            
           </div>
            </div>

              </FilterWrapper>
              
              
               <FilterWrapper>
          <div className="filterBox">
              <div style={{width:"100%"}}>
                <div className="flex align-items gap-20">
                <div style={{position:"relative"}}>
                    <input
                      type="text"
                      name="hotelName"
                      placeholder="Hotel Name"
                     value={hoteldata?.hotelName || ""}
                     onChange={handleDetailData}
                    
                     // onKeyDown={handleKeyDown}
                    />
                    { showSuggestions && suggestions.length > 0 && (
              <div ref={autoSuggestionRef}>
                 <AutoSuggestion
    fromCityList={suggestions}
    setCityName={(name) =>
      setHotelData((prev) => ({
        ...prev,
        hotelName: name,
      }))
    }
    setCityId={(id) =>
      setHotelData((prev) => ({
        ...prev,
        searchId: id, // Set the selected city ID
      }))
    }
   
    setShowCity={setShowSuggestions}
    showCity={{ fromCityShow: true }}
    cityNameKey="cityName"
    inputElement={null}
  />
              
              </div>
)}
                  </div>
                <div>
                    <input
                      type="text"
                      name="hotelCode"
                      placeholder="Hotel Code"
                     value={hoteldata?.hotelCode || ""}
                     onChange={handleDetailData}
                   
                     // onKeyDown={handleKeyDown}
                    />
                  </div>
                
                
                  <div className="input-field">
                    <select
                      className="input_select_field"
                      name="active"
                     value={hoteldata?.active}
                      onChange={handleDetailData}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="" selected={hoteldata?.active === null}>status</option> 
                     <>
                      <option value={"true"}>ACTIVE</option>
                     <option value={"false"}>INACTIVE</option>
                      </>
                    </select>
                  </div>
                 
                 
                 
                 
                 
                  {/* <div>
                    <input
                      type="text"
                      name="cityId"
                      placeholder="City Id"
                      value={hoteldata?.cityId}
                     // onChange={(e) => handleDetailData(e, "number")}
                      maxLength={10}
                     // onKeyDown={handleKeyDown}
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="feedSource"
                      placeholder="Feed Source"
                      value={hoteldata?.feedSource}
                     // onChange={(e) => handleDetailData(e, "number")}
                      maxLength={10}
                     // onKeyDown={handleKeyDown}
                    />
                  </div> */}

                 
                 
                  <div className="button">
                    <button
                      className="userlist_btn"
                      onClick={(e) => showHotelList(0, "search")}
                    >
                      Search
                    </button>
                  </div>

                  <div className="button">
                    <button
                      className="refresh-btn"
                      onClick={(e) => showHotelList(0, "refresh")}
                    >
                      <i className="fa fa-refresh"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

              </FilterWrapper>
          </div>

          <div className="table-loader">
          {loading && <LocalLoader className="tableLoader" />}
            <TableWrapper className="table-card-wrapper">
              <table className="table">
                <thead>
                  <tr>
                   <th>Hotel Code</th>
                   <th>Hotel Name</th>
                    <th>Feed Source</th>
                    <th>Last Update</th>
                    <th>Status</th>
                    <th>Action</th>
                   
                   
                  </tr>
                </thead>
                <tbody>
                    {hotelList && 
                    hotelList?.map((items)=>{
                          const dateTimeString = items?.lastUpdatedAt;
                           let [date, time] = dateTimeString.split("T");
                           let newTime = time.slice(0, 8);
                        return(
                         <>
                            <tr>
                            <td>{items?.code}</td>
                            <td>{items?.name}</td>
                            <td>{items?.feedSource}</td>
                            <td>{date + " " + newTime}</td>
                            <td>
                            <div
                                    className={`custom-toggle toggle_button ${
                                      items.active === true ? "active" : ""
                                    }`}
                                    onClick={() =>
                                      updateStatus(items.id, items.active)
                                    }
                                    styled={{
                                      margin: "0",
                                      marginRight: "12px",
                                    }}
                                  >
                                    <div className="slider"></div>
                                  </div>
                            </td>


                            <td className="user_action_btn button">
                  <span>
                    <button onClick={() => handleViewCity(items?.id)}>
                    <i class="fa-solid fa-pen-to-square update" aria-hidden="true"></i>

                    </button>
                  </span>
                            </td>
                             </tr>
                         </>


                        )
                      

                    })
                    
                    
                    }

                </tbody>
              </table>
            </TableWrapper>
            </div>
            
            {totalPages > 1 && (
        <Pagination
         items={showHotelList}
          itemsPerPage={pageSize}
          setitemsPerPage={setPageSize}
          currentPage={currPage}
          setcurrentPage={(page)=>currPageSet(page)}
          totalPages={totalPages}
          forcePage={currPage}
        />
      )}
   
            
            
            </div>
        
        
       
        
         </div>
          {showHotel &&  <ModalPopUp>
         <div className="subadmin_container justify-between flex column gap-20" style={{width:"65%"}}>
         <div style={{padding:"30px",flex:"1 1 100%"}}>
            <p className="fs-5 fw-bold">Add New Hotel:</p>
           
           <div className="flex gap-10 mt-20">

            <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Hotel Code:</label>
                
                </div >
                <Input
                  type="text"
               
                placeholder="Hotel Code"
                  name="code"
                 value={newHotelData.code}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.code && (
                  <p className="error fs-12 mt-10">{errors.code}</p>
                )}
              </div>

              <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Hotel Name</label>
                
                </div >
                <Input
                  type="text"
               
                placeholder="Hotel Name"
                  name="name"
                 value={newHotelData.name}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.name && (
                  <p className="error fs-12 mt-10">{errors.name}</p>
                )}
              </div>

              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Check In</label>
                
                </div>
                <Input
                  type="text"
                
                  placeholder="Check In"
                  name="checkInTime"
                value={newHotelData?.checkInTime}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.checkInTime && (
                  <p className="error fs-12 mt-10">{errors.checkInTime}</p>
                )}
              </div>
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label className="fw-bold">Check Out:</label>
                
                </div>
                <Input
                  type="text"
             
                  placeholder="Check Out"
                  name="checkOutTime"
                value={newHotelData?.checkOutTime}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.checkOutTime && (
                  <p className="error fs-12 mt-10">{errors.checkOutTime}</p>
                )}
              </div>

              
          
          
          
          </div>
        
        
        
        
          <div className="flex gap-10 mt-20">
             
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">City Id:</label>
                
                </div>
                <Input
                  type="text"
               
                  placeholder="City Id"
                  name="cityId"
                value={newHotelData?.cityId}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.cityId && (
                  <p className="error fs-12 mt-10">{errors.cityId}</p>
                )}
              </div>
             
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">City Name:</label>
                
                </div>
                <Input
                  type="text"
                
                  placeholder="City name"
                  name="cityName"
                value={newHotelData?.cityName}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.cityName && (
                  <p className="error fs-12 mt-10">{errors.cityName}</p>
                )}
              </div>
              
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Geo Point:</label>
                
                </div>
                <Input
                  type="text"
                
                  placeholder="Geo Point"
                  name="geoPoint"
                value={newHotelData?.geoPoint}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.geoPoint && (
                  <p className="error fs-12 mt-10">{errors.geoPoint}</p>
                )}
              </div>
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Country Code:</label>
                
                </div>
                <Input
                  type="text"
             
                  placeholder="Country Code"
                  name="countryCode"
                value={newHotelData?.countryCode}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.countryCode && (
                  <p className="error fs-12 mt-10">{errors.countryCode}</p>
                )}
              </div>
            
            
              </div>
              
            
       
          
          <div className="flex gap-10 mt-20">
          <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Phone:</label>
                
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="Phone"
                  name="phone"
                value={newHotelData?.phone}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.phone && (
                  <p className="error fs-12 mt-10">{errors.phone}</p>
                )}
              </div>
        
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Email:</label>
                
                </div>
                <Input
                  type="text"
             
                  placeholder="Email"
                  name="email"
                value={newHotelData?.email}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.email && (
                  <p className="error fs-12 mt-10">{errors.email}</p>
                )}
              </div>

              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Fax:</label>
                
                </div>
                <Input
                  type="text"
                  
                  placeholder="Fax"
                  name="fax"
                value={newHotelData?.fax}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.fax && (
                  <p className="error fs-12 mt-10">{errors.fax}</p>
                )}
              </div>
        
        
        
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Star Rating</label>
                
                </div>
                <Input
                  type="text"
                 
                  placeholder="star Rating"
                  name="starRating"
                value={newHotelData?.starRating}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.starRating && (
                  <p className="error fs-12 mt-10">{errors.starRating}</p>
                )}
              </div>

              
              

             
          </div>
             <div className="flex gap-10 mt-20">

             <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Address:</label>
                
                </div>
                <Input
                  type="text"
                
                  placeholder="Phone"
                  name="address"
                value={newHotelData?.address}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.address && (
                  <p className="error fs-12 mt-10">{errors.address}</p>
                )}
              </div>
             
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Pin Code:</label>
                
                </div>
                <Input
                  type="text"
             
                  placeholder="Pin code"
                  name="pinCode"
                value={newHotelData?.pinCode}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.pinCode && (
                  <p className="error fs-12 mt-10">{errors.pinCode}</p>
                )}
              </div>
             
                <div className="input-field"  style={{flex:"1 1 50%"}}>
              <div className="labelname mb-5">
                  <label className="fw-bold">Status:</label>
                
                </div>
                    <select
                    style={{width:"100%", maxWidth:"330px"}}
                      className="input_select_field"
                      name="active"
                   value={newHotelData.active}
                  onChange={handleModalInputChange}
                    >
                 
                   
                      <option value="">status</option> 
                     <>
                      <option value={true}>ACTIVE</option>
                     <option value={false}>INACTIVE</option>
                      </>
                    </select>
                    {errors.active && (
                  <p className="error fs-12 mt-10">{errors.active}</p>
                )}
                  </div>
                  <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Feed Source:</label>
                
                </div>
                <Input
                  type="text"
                
                  placeholder="Feed Source"
                  name="feedSource"
                value={newHotelData?.feedSource}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.feedSource && (
                  <p className="error fs-12 mt-10">{errors.feedSource}</p>
                )}
                  </div>
                 
               
                  
                  </div>
          

         <div className="flex gap-10 mt-20">
          

              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Discription:</label>
                
                </div>
                <textarea
                  type="text"
                 style={{width:"100%", height:"100%"}}
                 
                  name="description"
                value={newHotelData?.description}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.description && (
                  <p className="error fs-12 mt-10">{errors.description}</p>
                )}
              </div>

              
              

             
          </div>
          <div className="flex gap-10 mt-20">
          
            
              
              

             
          </div>
         
        

         </div>
       
         <div className="flex gap-10" style={{padding:"30px"}}>
        
         <div>
          <button onClick={()=>handleAddHotel("cancle")} className="userlist_btn">Cancle</button>
        </div>
        <div>
          <button onClick={handleSubmit} className="userlist_btn">Submit</button>
        </div>
         </div>
         </div>

         </ModalPopUp>}
        
        
        </>
    )

}

export default HotelList;